import { Months } from '../models/Apertura';

import { ColumnProps } from 'antd/lib/table';
import { RegistroEnviardo } from './Responses';

export const AprobacionesTableColumns: Array<ColumnProps<RegistroEnviardo>> = [
    {
        title: 'Municipio',
        dataIndex: 'municipioNombre',
        key: 'municipioNombre',
        sorter: (a: RegistroEnviardo, b: RegistroEnviardo) => a.municipioId - b.municipioId
    },
    {
        title: 'Mes',
        dataIndex: 'mesString',
        key: 'mesString',
        filters: Months.map(month => ({ text: month, value: month })),
        onFilter: (value: any, record: any) => record.mesString.indexOf(value) === 0,
        sorter: (a: RegistroEnviardo, b: RegistroEnviardo) => a.mesString.length - b.mesString.length
    },
    {
        title: 'Ejercicio',
        dataIndex: 'ejercicio',
        key: 'ejercicio',
        sorter: (a: RegistroEnviardo, b: RegistroEnviardo) => a.ejercicio - b.ejercicio
    },
    {
        title: 'Estatus',
        dataIndex: 'estado',
        key: 'estado',
        sorter: (a: RegistroEnviardo, b: RegistroEnviardo) => a.estado.length - b.estado.length,
    },
    {
        title: 'Tipo',
        dataIndex: 'tipoImpuesto',
        key: 'tipoImpuesto',
        filters: [
            {
                text: 'Agua',
                value: 'Agua'
            },
            {
                text: 'Predial',
                value: 'Predial'
            }
        ],
        sorter: (a: RegistroEnviardo, b: RegistroEnviardo) =>
            a.tipoImpuesto.length - b.tipoImpuesto.length,
        onFilter: (value: any, record: any) => record.tipoImpuesto.indexOf(value) === 0
    },
    {
        title: 'Última Modificación',
        dataIndex: 'modificacionFecha',
        key: 'modificacionFecha',
    }
];
